module.exports = __webpack_public_path__ + "img/style-tile-desktop.6d8a217e.png";